<script setup lang="ts">
import { type ErrorType } from '@/types/Errors'

defineProps<{
    errors: ErrorType
    value?: string
    label?: string
    required?: boolean
    field: string
    missingText?: string
    containerClasses?: string
}>()
</script>
<template>
    <div class="form-group" :class="containerClasses">
        <label v-if="!!label" class="text-xs uppercase font-bold">{{ label }}</label>
        <p class="text-xs">{{ value ?? missingText }}</p>
        <i
            class="text-danger text-xs"
            v-if="
                !!field &&
                errors.hasOwnProperty(field) &&
                !!errors[field] &&
                errors[field].length > 0
            "
            >{{ errors[field][0] }}</i
        >
    </div>
</template>
<style scoped></style>
